<template>
    <div class="modal modal-todo modal-send-to-lost fade" tabindex="-1" role="dialog" aria-labelledby="send-to-lost-modal-label" aria-hidden="true" ref="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }} - {{ name }}</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="sendToLost">
                        <div class="form-group">
                            <label for="lost-reason">Choose Reason<span class="text-danger">*</span></label>
                            <v-select id="lost-reason" v-model="selectedReason" label="label" placeholder="Select" :class="{ 'is-invalid': errors.reason }" :options="reasonOptions" :reduce="option => option.value" :disabled="isLoadingReasons || reasonOptions.length === 0" :clearable="false" />
                            <div v-if="errors.reason" class="text-small text-danger">{{ errors.reason }}</div>
                        </div>
                        <div class="form-group">
                            <label for="lost-notes">Notes<span class="text-danger">*</span></label>
                            <textarea id="lost-notes" class="form-control" v-model="notes" rows="4" placeholder="Type here..."></textarea>
                            <div v-if="errors.notes" class="text-small text-danger">{{ errors.notes }}</div>
                        </div>
                        <button type="submit" class="btn btn-submit btn-block mt-3 btn-primary">
                            Save
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { getLostReasons } from '../../../services/api/to-do';

export default {
    name: 'SendToLostModal',
    components: { 'v-select': vSelect},
    data() {
        return {
            name: '',
            title: 'Send to Lost',
            selectedReason: null,
            reasonOptions: [],
            notes: '',
            errors: {
                reason: '',
                notes: ''
            },
            isLoadingReasons: false
        }
    },
    mounted() {
        document.body.appendChild(this.$el);
    },
    watch: {
        selectedReason(newVal) {
            if (newVal) {
                this.errors.reason = '';
            }
        },
        notes(newVal) {
            if (newVal.trim()) this.errors.notes = '';
        }
    },
    methods: {
        openModal(content) {
            this.name = content.name;
            this.title = content.title;
            this.selectedReason = null;
            this.notes = '';
            this.errors.reason = '';
            this.errors.notes = '';
            this.$nextTick(() => {
                this.fetchReasons();
                
                $(this.$refs.modal).modal({
                    backdrop: 'static',
                    keyboard: false
                });
            });
        },
        closeModal() {
            $(this.$refs.modal).modal('hide');

            this.selectedReason = null;
            this.notes = '';
            this.errors.reason = '';
            this.errors.notes = '';
        },
        async fetchReasons() {
            this.isLoadingReasons = true;

            try {
                const response = await getLostReasons();
                const data = response.data.data;

                this.reasonOptions = data.map(item => ({
                    label: item.name,
                    value: item.id,
                    original: item
                }));
            } catch (error) {
                console.error('Failed to fetch reasons:', error);
            } finally {
                this.isLoadingReasons = false;
            }
        },
        sendToLost() {
            this.errors = { reason: '', notes: '' };

            if (!this.selectedReason) {
                this.errors.reason = 'Please select a reason.';
            }

            if (!this.notes.trim()) {
                this.errors.notes = 'Notes cannot be empty.';
            }

            if (this.errors.reason || this.errors.notes) {
                return;
            }

            this.$emit('save', {
                reason_id: this.selectedReason,
                notes: this.notes
            })

            this.closeModal()
        }
    }
}
</script>
